import { Injectable } from "@angular/core";
import { ValidationErrors } from "@angular/forms";
import { Observable, Subject } from "rxjs";
import { ErrorDetail } from "./errors-details/errors-details.component";

export interface ValidationErrorsService {
  currentErrors: Map<string, ErrorDetail>;
  addValidationError(key: string, errorDetail: ErrorDetail): void;
  clearValidationError(key: string): void;
  changed$: Observable<ErrorDetail[]>;
  getErrorDescriptionText(allErrors: ValidationErrors): string;
}
export abstract class ValidationErrorsService implements ValidationErrorsService {
  static attributeName = "avanoValidationErrorBreadcrumb";
}


type BuiltInValidationErrorTypes =
  {min: number, actual: number} & // min
  {max: number, actual: number} & // max
  {requiredLength: number, actualLength: number}; // minlength and maxlength

@Injectable({providedIn: 'root'})
export class ExampleValidationErrorsService implements ValidationErrorsService {
  private errorDescriptions: Map<string, (errorInput: BuiltInValidationErrorTypes) => string> = new Map([
    ['min', (errorReason) => `Minimum value is ${errorReason.min}`],
    ['max', (errorReason) => `Maximum value is ${errorReason.max}`],
    ['required', () => "Input is required"],
    // // ['requiredTrue', 'x'],
    // // ['email', 'x'],
    ['minlength', (errorReason) => `Input should be at least ${errorReason.requiredLength} characters long.`],
    ['maxlength', (errorReason) => `Input should be at most ${errorReason.requiredLength} characters long.`],
    // ['pattern', 'x'],
    // ['nullValidator', 'x'],
    // ['compose', 'x'],
    // ['composeAsync', 'x'],
    // Built-In Validators: https://angular.io/api/forms/Validators
  ])
  changed$: Subject<ErrorDetail[]> = new Subject<ErrorDetail[]>();
  currentErrors: Map<string, ErrorDetail> = new Map();

  addValidationError(key: string, errorDetail: ErrorDetail): void {
    this.currentErrors.set(key, errorDetail);
    this.changed$.next(Array.from(this.currentErrors.values()));
  }

  clearValidationError(key: string): void {
    this.currentErrors.delete(key);
    this.changed$.next(Array.from(this.currentErrors.values()));
  }

  getErrorDescriptionText(allErrors: ValidationErrors): string {
    const firstUsableErrorDescription = Object.entries(allErrors)
      .map(([key, value]) => this.errorDescriptions.get(key)?.(value))
      .find(description => description !== undefined);
    return firstUsableErrorDescription ?? 'Invalid input';
  }
}

